module.exports = __webpack_public_path__ + "static/media/Zone1RightHipOverlay.30f839df.png";